/* Pairing Card (snippets/cmp-set-card.liquid, Spec #265): die Karte bietet den anderen Gurt an, in zwei Richtungen
   (#590). Auf der Seite des Halsbands die Leine (`data-direction` fehlt oder ist „leash“), auf der Seite der Leine das
   Halsband („collar“), dieses mit Größe.

   Die Farbe auf der Karte folgt jeder Carrier Colour des Gurts der Seite (gleicher Hex der Swatches, nie der übersetzte
   Name), bis der Kunde auf der Karte selbst eine Farbe wählt. Beim Kauf hängt sich der angebotene Gurt über das Event
   cmp:cart-items an denselben /cart/add.js-Request: das Event schicken die Cart Gateway und der einfache Kauf des
   Konfigurators (packages/configurator/src/cart-section.ts, `askForCartItems`); der Ersatz einer Cart Edit fragt nicht.
   Ist die gewählte Variante eine Vorbestellung, trägt ihre Zeile Name und Wert der Antwort, die Liquid ihr gab
   (`preorder`, ADR-0022, #544): ihr eigenes Versanddatum, und dieses versteckt als `_ships_from` (#649).

   Das Halsband hat Größen: es ist ohne Größe nicht angekreuzt. Ankreuzen ohne Größe fragt nach ihr wie der
   Warenkorb-Vorschlag (#461): die Größen-Zeile sagt „Größe?“, die noch erhältlichen Größen pulsieren (Klasse
   `is-asking`), der Satz `data-t-size` ist nur für den Screenreader da, und der Fokus geht auf die erste erhältliche
   Größe (wie `tellOfferError` in packages/configurator/src/match-suggestion.ts, das das Theme-Asset nicht
   importieren kann). Eine Größe wählen kreuzt an.

   Der Zustand je Karte: `colour`, `size` (null ohne Größe) und `picked` (eine auf der Karte gewählte Farbe; danach
   folgt sie dem Gurt der Seite nicht mehr). Angekreuzt ist, was die Checkbox sagt. `choose`, `chooseSize` und `tick`
   ändern ihn, `render` zeigt ihn; wer die Karte von außen setzt (#592), geht über sie.

   Nach einem Leash Hint (#592) sagt der Konfigurator der Leine das gemerkte Halsband an: cmp:paired-collar mit
   `detail` `{carrierVariantId, spellings, tick}` (packages/configurator/src/paired-collar.ts). Heißt die Regel
   ankreuzen und ist die Variante zu haben, steht die Karte auf ihrer Farbe und Größe, als Wahl des Kunden (`picked`),
   angekreuzt, mit der Notiz über dem Halsband (`carried`). Wer eine so angekreuzte Karte abhakt, bittet den
   Konfigurator mit cmp:forget-paired-collar, das Halsband zu vergessen, und hat ab da die gewöhnliche Karte: ohne
   Größe, die Farbe wieder der Leine folgend. Eine andere Farbe oder Größe auf der Karte merkt sich niemand: hakt die
   Karte selbst ab, weil die Größe in der neuen Farbe fehlt, bleibt das Halsband gemerkt, und eine Größe kreuzt es mit
   der Notiz wieder an.

   Ist die gemerkte Variante nicht mehr zu haben (#593), aber ihre Farbe in einer anderen Größe, steht die Karte auf
   der Farbe, ohne Größe, nicht angekreuzt, mit der Notiz über die ausverkaufte Größe (`soldOut`), und das Halsband
   bleibt `carried`: eine Größe kreuzt an, und die Notiz sagt dann, dass es mit in den Warenkorb kommt. Ist die Farbe
   in keiner Größe zu haben, ist es die gewöhnliche Karte. Blieben Charm Sets am Halsband (`spellings`), tritt die
   Karte zurück (#597): sie ist verborgen, und der Konfigurator zeichnet an ihrer Stelle die Erinnerung an das
   wartende Halsband (die Regel kreuzt dort nie an). Kommt die Seite aus dem Back/Forward-Cache zurück und warten die
   Charm Sets nicht mehr am Halsband (es ist im Warenkorb oder geleert), vergisst der Konfigurator es, nimmt die
   Erinnerung weg und sagt cmp:paired-collar-withdrawn an: die Karte kommt zurück, die gewöhnliche. */
(function () {
  var ASKING = 'is-asking';
  document.querySelectorAll('[data-cmp-set-card]').forEach(function (card) {
    if (card.dataset.cmpInit) return;
    card.dataset.cmpInit = '1';
    var variants;
    try { variants = JSON.parse(card.querySelector('[data-cmp-set-variants]').textContent); } catch (err) { return; }
    if (!Array.isArray(variants) || !variants.length) return;
    var sws = Array.prototype.slice.call(card.querySelectorAll('[data-cmp-set-value]'));
    var sizes = Array.prototype.slice.call(card.querySelectorAll('[data-cmp-set-size]'));
    var check = card.querySelector('[data-cmp-set-check]');
    var error = card.querySelector('[data-cmp-set-error]');
    var note = card.querySelector('[data-cmp-set-note]');
    var sized = variants.some(function (v) { return typeof v.size === 'string'; });

    var colour = (variants.find(function (v) { return v.available; }) || variants[0]).color;
    var size = null;
    // Eine auf der Karte gewählte Farbe gilt: danach folgt die Karte der Carrier Colour nicht mehr (Spec #265)
    var picked = false;
    // Vom Konfigurator auf dem gemerkten Halsband angekreuzt (#592), oder auf dessen Farbe gestellt, wo seine Größe
    // ausverkauft ist (#593), bis der Kunde abhakt
    var carried = false;
    // Die gemerkte, inzwischen ausverkaufte Variante (#593): ihre Farbe und Größe
    var soldOut = null;

    /** Die erhältlichen Varianten in Farbe `c` (und Größe `s`, wo eine genannt ist), in der Reihenfolge der Karte. */
    function availableVariants(c, s) {
      return variants.filter(function (v) {
        return v.available && v.color === c && (s === undefined || s === null || v.size === s);
      });
    }
    /** Ob es in Farbe `c` (und Größe `s`, wo eine genannt ist) eine erhältliche Variante gibt. */
    function availableIn(c, s) {
      return availableVariants(c, s).length > 0;
    }
    /** Die Variante, die angekreuzt in den Warenkorb geht; keine ohne Größe, wo es Größen gibt. */
    function chosen() {
      if (sized && size === null) return undefined;
      return availableVariants(colour, size)[0];
    }
    /** Was die Karte zeigt: die gewählte Variante, sonst die erste erhältliche ihrer Farbe. */
    function shownVariant() {
      return chosen() || availableVariants(colour)[0] ||
        variants.find(function (v) { return v.color === colour; }) || variants[0];
    }

    function render() {
      var v = shownVariant();
      sws.forEach(function (b) {
        var on = b.dataset.cmpSetValue === colour;
        b.classList.toggle('is-active', on);
        if (b.hasAttribute('aria-pressed')) b.setAttribute('aria-pressed', String(on));
      });
      sizes.forEach(function (b) {
        var on = b.dataset.cmpSetSize === size;
        b.disabled = !availableIn(colour, b.dataset.cmpSetSize);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', String(on));
      });
      card.querySelectorAll('[data-cmp-set-color-name]').forEach(function (el) { el.textContent = v.color; });
      var full = card.querySelector('[data-cmp-set-full]');
      if (full) { full.textContent = v.full || ''; full.hidden = !v.full; }
      card.querySelector('[data-cmp-set-now]').textContent = v.now;
      var img = card.querySelector('[data-cmp-set-img]');
      if (img && v.img) img.src = v.img;
      tint(colour);
      showNote();
    }
    /** Die Notiz, solange die Karte das mitgenommene Halsband angekreuzt hat: in Farbe und Größe, wie sie stehen.
     * Davor, solange seine Größe ausverkauft ist und die Karte in seiner Farbe ohne Größe steht (#593): welche, und
     * dass eine andere es mitnimmt. */
    function showNote() {
      if (!note) return;
      var ticked = carried && check.checked;
      var text = '';
      if (ticked) {
        text = (note.dataset.tCarried || '').replace('%{colour}', colour).replace('%{size}', size || '');
      } else if (carried && soldOut && soldOut.color === colour && size === null) {
        text = (note.dataset.tSoldOut || '').replace('%{size}', soldOut.size);
      }
      note.hidden = !text;
      note.textContent = text;
    }
    // Kopfzeile + Rahmen in der Farbe des angebotenen Gurts (Daniel 2026-10-07); Schrift hell/dunkel je nach Helligkeit
    function tint(color) {
      var b = sws.find(function (x) { return x.dataset.cmpSetValue === color; });
      var hex = b && b.dataset.cmpSetHex;
      if (!hex || !/^#[0-9a-f]{6}$/i.test(hex)) return;
      var r = parseInt(hex.substr(1, 2), 16), g = parseInt(hex.substr(3, 2), 16), bl = parseInt(hex.substr(5, 2), 16);
      var light = (0.299 * r + 0.587 * g + 0.114 * bl) > 160;
      card.style.setProperty('--cmp-match', hex);
      card.style.setProperty('--cmp-match-ink', light ? '#402e2a' : '#ffffff');
    }

    /** Kreuzt an oder ab. Eine Karte mit Größen kreuzt ohne Größe nicht an. */
    function tick(on) {
      check.checked = on && !(sized && size === null);
      if (check.checked) stopAsking();
      showNote();
    }
    /** Wählt Farbe `c`, wo sie zu haben ist; eine darin ausverkaufte Größe ist nicht mehr gewählt, und ohne Größe
     * ist die Karte nicht mehr angekreuzt. Ob die Farbe gewählt ist. */
    function choose(c) {
      if (!availableIn(c)) return false;
      colour = c;
      if (size !== null && !availableIn(c, size)) {
        size = null;
        tick(false);
      }
      render();
      return true;
    }
    /** Wählt Größe `s` in der Farbe der Karte, wo sie zu haben ist. Ob sie gewählt ist. */
    function chooseSize(s) {
      if (!availableIn(colour, s)) return false;
      size = s;
      render();
      return true;
    }

    function stopAsking() {
      card.classList.remove(ASKING);
      if (error) error.hidden = true;
    }
    function askForSize() {
      if (error) { error.textContent = card.dataset.tSize || ''; error.hidden = false; }
      card.classList.remove(ASKING);
      /* Ein Layout-Lesen zwischen Wegnehmen und Setzen spielt das Pulsieren neu ab. */
      card.getBoundingClientRect();
      card.classList.add(ASKING);
      var first = sizes.find(function (b) { return !b.disabled; });
      if (first) first.focus({ preventScroll: true });
      card.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    function fromStrap() {
      if (picked) return;
      var a = document.querySelector('.cmp-pdp__swatches .is-active[data-cmp-hex]');
      if (!a) return;
      var hex = a.dataset.cmpHex.toLowerCase();
      var b = sws.find(function (x) { return x.dataset.cmpSetHex.toLowerCase() === hex; });
      if (b) choose(b.dataset.cmpSetValue);
    }
    // Ausverkaufte Farben nicht wählbar
    sws.forEach(function (b) {
      if (!availableIn(b.dataset.cmpSetValue)) { b.disabled = true; b.classList.add('is-off'); }
    });

    card.addEventListener('click', function (e) {
      var s = e.target.closest('[data-cmp-set-size]');
      if (s && !s.disabled) {
        if (chooseSize(s.dataset.cmpSetSize)) tick(true);
        return;
      }
      var b = e.target.closest('[data-cmp-set-value]');
      if (!b || b.disabled) return;
      picked = true;
      // Eine Farbe ist ein Wunsch nach dem Gurt: sie kreuzt an, wo die Karte damit vollständig ist
      if (choose(b.dataset.cmpSetValue) && !check.checked) tick(true);
    });
    check.addEventListener('click', function (e) {
      if (!check.checked) {
        stopAsking();
        if (carried) forgetCarried();
        return;
      }
      if (sized && size === null) {
        e.preventDefault();
        askForSize();
      }
    });
    /** Der Kunde hakt das mitgenommene Halsband ab: der Konfigurator vergisst es, und die Karte ist die gewöhnliche. */
    function forgetCarried() {
      carried = false;
      soldOut = null;
      picked = false;
      size = null;
      card.dispatchEvent(new CustomEvent('cmp:forget-paired-collar', { bubbles: true }));
      render();
      fromStrap();
    }
    /** Das Halsband, das der Konfigurator nach einem Leash Hint ansagt (#592). */
    function answerPairedCollar(e) {
      var d = e.detail;
      if (card.dataset.direction !== 'collar' || !d) return;
      // Blieben Charm Sets am Halsband, tritt die Karte vor der Erinnerung des Konfigurators zurück (#597)
      if (Array.isArray(d.spellings) && d.spellings.length) {
        card.hidden = true;
        return;
      }
      var v = variants.find(function (x) { return String(x.id) === String(d.carrierVariantId); });
      if (!v) return;
      // Wo die Regel nicht ankreuzt (Charm Sets blieben, ein Halsband ohne Leine im Warenkorb), gilt auch keine
      // Notiz über eine ausverkaufte Größe: die gewöhnliche Karte
      if (!d.tick) return;
      // Die Größe ist ausverkauft (#593): die Farbe ohne Größe, wo sie noch eine andere hat; sonst die gewöhnliche Karte
      if (!v.available && (!sized || !availableIn(v.color))) return;
      picked = true;
      carried = true;
      if (!v.available) {
        soldOut = { color: v.color, size: v.size };
        size = null;
        choose(v.color);
        return;
      }
      choose(v.color);
      if (sized) chooseSize(v.size);
      tick(true);
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('.cmp-pdp__swatches')) setTimeout(fromStrap, 0);
    });
    // Eine im Sheet gewählte Carrier Colour (Carrier Picker) wählt den Swatch der Seite, ohne Klick auf ihn
    document.addEventListener('cmp:choose-carrier-colour', function () { setTimeout(fromStrap, 0); });
    document.addEventListener('cmp:paired-collar', answerPairedCollar);
    /* Zurückgezogen wird nur ein Halsband, an dem Charm Sets blieben (#593): die Karte, die davor zurücktrat, kommt
       zurück, die gewöhnliche (#597). */
    document.addEventListener('cmp:paired-collar-withdrawn', function () {
      if (card.dataset.direction === 'collar') card.hidden = false;
    });
    document.addEventListener('cmp:cart-items', function (e) {
      // `setLeashAdded` ist Daniels Name: der andere Gurt ist schon dabei, so dass zwei Karten einen anhängen
      if (e.detail.setLeashAdded) return;
      if (!check.checked) return;
      var v = chosen();
      if (!v) return;
      e.detail.setLeashAdded = true;
      var line = { id: v.id, quantity: e.detail.count || 1 };
      if (v.preorder) {
        line.properties = {};
        line.properties[v.preorder.name] = v.preorder.value;
        // Ihr Datum versteckt, wie der Konfigurator es schreibt (`preorderProperty` in der Domain, #649)
        line.properties._ships_from = v.preorder.shipsFrom + (v.preorder.approximate ? '~' : '');
      }
      e.detail.items.push(line);
    });
    /* Das Halsband zeigt seine Größen von Anfang an nach der Farbe, in der es steht. Die Leine zeigt, was Liquid
       rendert, bis die Carrier Colour der Seite sie wählt, wie vor #590. */
    if (sized) render();
    fromStrap();
  });
})();
